import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop({setCurrentChapter}) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== '/') {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      });

      setCurrentChapter(0)

    }
  }, [pathname, setCurrentChapter]);

  return null;
}